import api from '@/api';

const originalCategory = {
  name: null,
  description: null,
  slug: null,
  parent_id: null,
};

export default {
  namespaced: true,

  state: {
    categories: [],
    currentCategory: {},
    query: {
      size: 10,
      from: 0,
    },
    filters: {
      searchQuery: '',
    },
    sortBy: {
      field: 'name.raw',
      direction: 'asc',
    },
    error: null,
  },
  mutations: {
    SET_CATEGORIES(state, payload) {
      state.categories = payload;
    },
    RESET_CURRENT_CATEGORY(state) {
      state.currentCategory = { ...originalCategory };
    },
    SET_CURRENT_CATEGORY(state, payload) {
      state.currentCategory = payload;
    },
    SET_SORT_FIELD(state, field) {
      state.sortBy.field = field;
    },
    SET_SORT_DIRECTION(state, dir) {
      state.sortBy.direction = dir;
    },
    setSearchQuery(state, term) {
      state.filters.searchQuery = term;
    },
  },
  actions: {
    async list({ state, commit }, params) {
      let response;

      let url = '/eformmanagement/categories';

      if (params && params.flat) {
        url = `${url}/flat`;
      }

      const size = params && params.size ? params.size : state.query.size;
      const from = params && params.from ? params.from : state.query.from;

      const filter = {
        size,
        from,
        sort: [
          {
            [state.sortBy.field]: {
              order: state.sortBy.direction,
            },
          },
        ],
        query: {
          bool: {
            must: [
              {
                bool: {
                  should: [
                    {
                      bool: {
                        should: [
                          {
                            match: {
                              name: {
                                query: state.filters.searchQuery,
                                operator: 'and',
                                zero_terms_query: 'all',
                                fuzziness: 'AUTO',
                              },
                            },
                          },
                          {
                            match_phrase_prefix: {
                              name: {
                                query: state.filters.searchQuery,
                                slop: 50,
                              },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
          },
        },
      };

      try {
        response = await api().put(url, { filter });
        const { category } = response.data.data;
        commit('SET_CATEGORIES', category);
        return Promise.resolve(category);
      } catch (err) {
        commit('SET_CATEGORIES', []);
        return Promise.resolve([]);
      }
    },

    async quickList({ state }, filterTerm) {
      let resp;

      const query = {
        query: {
          bool: {
            must: [],
          },
        },
      };

      if (filterTerm) {
        query.query.bool.must.push({
          match_phrase_prefix: {
            name: {
              query: filterTerm,
              slop: 10,
            },
          },
        });
      }

      query.size = state.query.size;
      query.from = 0;

      try {
        resp = await api().put('/eformmanagement/categories/flat', { filter: query });
        // once we have data, format it into an id/label object
        const toReturn = resp.data.data.category.map(item => ({ id: item.id, name: item.name }));
        return Promise.resolve(toReturn);
      } catch (error) {
        if (error.response.status === 404 && error.response.data.data.length === 0) {
          return Promise.resolve([]);
        }
        return Promise.reject(error.response.data);
      }
    },

    async read({ commit }, id) {
      let response;

      try {
        response = await api().get(`/eformmanagement/category/${id}`);
        const { category } = response.data.data;
        commit('SET_CURRENT_CATEGORY', category[0]);
        return Promise.resolve(category[0]);
      } catch (err) {
        return Promise.reject(new Error(err));
      }
    },

    async edit({ state, commit, dispatch }) {
      let response;

      const payload = state.currentCategory;

      payload.description = payload.description ? payload.description : '';

      try {
        response = await api().put(`/eformmanagement/category/${payload.id}`, {
          category: payload,
        });
        dispatch('list');
        dispatch(
          'notifications/create',
          {
            body: 'The category was updated',
            type: 'success',
          },
          { root: true },
        );
        commit('RESET_CURRENT_CATEGORY');
        return Promise.resolve(response.data.data.category);
      } catch (err) {
        return Promise.reject(new Error(err));
      }
    },

    async add({ state, commit, dispatch }) {
      let response;

      const payload = state.currentCategory;

      payload.description = payload.description ? payload.description : '';

      try {
        response = await api().post('/eformmanagement/category', { category: payload });
        dispatch('list');
        dispatch(
          'notifications/create',
          {
            body: 'The category was created',
            type: 'success',
          },
          { root: true },
        );
        commit('RESET_CURRENT_CATEGORY');
        return Promise.resolve(response.data.data.category);
      } catch (err) {
        return Promise.reject(new Error(err));
      }
    },

    async delete({ commit, dispatch }, id) {
      api()
        .delete(`/eformmanagement/category/${id}`)
        .then(() => {
          dispatch('list');
          dispatch(
            'notifications/create',
            {
              body: 'The category was deleted',
              type: 'success',
            },
            { root: true },
          );
        })
        .catch((err) => {
          /**
           * In the case we have deleted the last item in the list
           */
          dispatch('list');
          commit('SET_ERROR', err);
        });
    },
  },
  getters: {
    optionsForMenu: state => state.categories.map(item => ({ id: item.id, name: item.name })),
    getParents: state => state.categories.filter(cat => !cat.parent_id),
    orderedCategories: (state) => {
      //get the categories and order them by parent -> child
      const dataset = state.categories;
      const hashTable = Object.create(null);
      dataset.forEach(aData => (hashTable[aData.id] = { ...aData, childNodes: [] }));
      const dataTree = [];
      dataset.forEach((aData) => {
        if (aData.parent_id) {
          hashTable[aData.parent_id].childNodes.push(hashTable[aData.id]);
        } else dataTree.push(hashTable[aData.id]);
      });

      let returnMenu = [];
      dataTree.forEach((item) => {
        returnMenu.push(item);
        if (item.childNodes.length > 0) {
          returnMenu = [...returnMenu, ...item.childNodes];
        }
      });
      return returnMenu;
    },
  },
};
